import { App } from 'antd'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import companyGroupQueryKeys from './companyGroupQueryKeys'
import { addSubsidiaries } from '../service/subsidiaryService'
import { Company } from '../../../types/company/Company'
import { CompanyGroup } from './getCompanyGroupOptions'

export const useAddSubsidiary = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: (subsidiaries: Partial<Company>[]) => {
      if (!companyId) throw new Error('Company ID is required')
      return addSubsidiaries(companyId, subsidiaries)
    },
    onSuccess: newList => {
      queryClient.setQueryData<CompanyGroup>(companyGroupQueryKeys.group({ companyId }), old =>
        old ? { ...old, subsidiaries: newList } : old
      )
      queryClient.invalidateQueries({ queryKey: companyGroupQueryKeys.group({ companyId }) })
      message.success(t('messages:createSuccess'))
    },
    onError: () => {
      message.error(t('messages:createError'))
    }
  })
}
